import Component from "./Component";

export default class ConditionalVisibility extends Component {
	constructor(element, data) {
		super(element, data);

		this.name = data.name;
		this.value = data.value;

		document.body.addEventListener("change", this.onChange.bind(this));

		document.querySelectorAll(`[name="${this.name}"]`).forEach($input => {
			this.handleInputState($input);
		});
	}

	onChange(event) {
		this.handleInputState(event.target);
	}

	handleInputState($input) {
		if (this.name !== $input.name) {
			return;
		}

		if ($input.type === "radio" && !$input.checked) {
			return;
		}

		if (this.value === $input.value) {
			this.show();
		} else {
			this.hide();
		}
	}

	show() {
		this.el.classList.add("is-visible");
	}

	hide() {
		this.el.classList.remove("is-visible");
	}
}
